import {useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {SirenPhoneCallConfig} from "./useGetSirenPhoneCallConfig";

export type AudioSlotInput = {
    ttsText?: string;
};

export type SirenPhoneCallConfigInput = {
    clientID?: string;
    departmentID?: string;
    preMessage?: AudioSlotInput;
    postDtmf?: AudioSlotInput;
    invalidOption?: AudioSlotInput;
    inboundCall?: AudioSlotInput;
    forwardingCall?: AudioSlotInput;
    alertNotFound?: AudioSlotInput;
    alreadyResponded?: AudioSlotInput;
    callForwardingEnabled?: boolean;
    callForwardingNumber?: string;
};

export function useUpsertSirenPhoneCallConfig() {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const save = async (input: SirenPhoneCallConfigInput): Promise<SirenPhoneCallConfig> => {
        setSaving(true);
        setError(null);
        try {
            const res = await platformAPI.post<SirenPhoneCallConfig>("api/siren/phone-call-config", input);
            return res.data;
        } catch {
            setError("Failed to save phone call config");
            throw new Error("save failed");
        } finally {
            setSaving(false);
        }
    };

    return {save, saving, error};
}
